import React from "react";

export default function PropertySummary({ mechanical, functional, application }) {
    const renderSection = (title, data) => {
        if (!data) return null;

        // Filter out fields that are internal, null/empty or unit-only
        const entries = Object.entries(data).filter(
            ([key, value]) =>
                !key.toLowerCase().endsWith("unit") &&
                key !== "mechanicalId" &&
                key !== "functionalId" &&
                key !== "applicationId" &&
                key !== "experiment" &&
                value !== null &&
                value !== ""
        );

        if (entries.length === 0) return null;

        return (
            <div className="mb-3 last-child-mb-0">
                <div className="fw-bold text-primary border-bottom mb-2 pb-1" style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {title}
                </div>
                <div className="d-flex flex-column gap-1">
                    {entries.map(([key, value]) => {
                        const unitKey = `${key}Unit`;
                        const unit = data[unitKey] || "";
                        const label = key
                            .replace(/([A-Z])/g, " $1")
                            .replace(/^./, (str) => str.toUpperCase());

                        return (
                            <div key={key} className="d-flex justify-content-between align-items-center gap-3" style={{ fontSize: '0.85rem' }}>
                                <span className="text-secondary">{label}:</span>
                                <span className="fw-medium text-dark text-end">
                                    {value} <small className="text-muted">{unit}</small>
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    const hasAnyData = (obj) => {
        if (!obj) return false;
        return Object.entries(obj).some(([key, val]) =>
            !key.toLowerCase().endsWith('unit') && val !== null && val !== "" && val !== undefined
        );
    };

    if (!hasAnyData(mechanical) && !hasAnyData(functional) && !hasAnyData(application)) {
        return <div className="text-muted small italic p-2">No properties recorded</div>;
    }

    return (
        <div className="property-summary-container p-1" style={{ minWidth: '220px' }}>
            {renderSection("Mechanical", mechanical)}
            {renderSection("Functional", functional)}
            {renderSection("Application", application)}
        </div>
    );
}
